import FooterIconButton from "@components/buttons/contact/FooterIconButton"
import { useRouter } from "next/router"
import { useTranslations } from "next-intl"
import { BsWhatsapp } from "react-icons/bs"

const WhatsappButton = () => {
  const t = useTranslations("nav")
  const router = useRouter()
  const { asPath } = router
  const phoneNumber =
    asPath === "/lp/linkedin"
      ? "971506004244"
      : asPath.startsWith("/lp/")
        ? "971507106247"
        : process.env.NEXT_PUBLIC_WHATSAPP_NUMBER
  const whatsappText = asPath.startsWith("/lp/")
    ? "Hey, I saw your ad on Google, can I get more info on eMenu please?"
    : "Hey, I'm interested in eMenu, please share more details."
  return (
    <FooterIconButton
      colorScheme={"green"}
      left={5}
      icon={<BsWhatsapp />}
      aria-label={t("whatsapp")}
      animateX={[-100, 35, 0]}
      onClick={() => {
        window.open(
          `https://wa.me/${phoneNumber}?text=${whatsappText}`,
          "_blank"
        )
      }}
    />
  )
}

export default WhatsappButton
